export const CDSchedule = ({ color }) => {
  return (
    <>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          d="M10.2998 21.6H5.49981C4.17433 21.6 3.09981 20.5254 3.09982 19.2L3.09992 4.80001C3.09992 3.47453 4.17444 2.40002 5.49992 2.40002H16.3002C17.6257 2.40002 18.7002 3.47454 18.7002 4.80002V11.4M13.9002 18.2L16.1002 20.4L20.9002 15.5998M7.3002 7.20002H14.5002M7.3002 10.8H14.5002M7.3002 14.4H10.9002"
          stroke={color}
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </>
  );
};
